import React from "react";
import {
  ArrowRight,
  Clock3,
  FileCheck2,
  ReceiptText,
  ScanFace,
  ShieldCheck,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { KycStep } from "../components/KycStep";

export function IntroStep({ onContinue }) {
  const { t } = useTranslation();

  return (
    <KycStep labelledBy="kyc-intro-title" className="intro-step">
      <div className="intro-step-content mx-auto flex min-h-full w-full max-w-xl flex-1 flex-col justify-center text-center">
        <span className="intro-step-icon mx-auto flex size-14 items-center justify-center rounded-2xl bg-gradient-to-br from-teal-50 to-cyan-50 text-teal-800 shadow-[0_0_0_8px_rgba(20,184,166,0.07)] ring-1 ring-teal-100">
          <ShieldCheck
            className="size-7"
            strokeWidth={2.2}
            aria-hidden="true"
          />
        </span>

        <h1
          id="kyc-intro-title"
          className="mt-6 text-[1.875rem] font-semibold leading-tight tracking-[-0.04em] text-slate-950 sm:text-[2rem]"
        >
          {t("kyc.intro.title")}
        </h1>
        <p className="mx-auto mt-3 max-w-md text-base leading-7 text-slate-600">
          {t("kyc.intro.description")}
        </p>

        <div className="intro-step-summary mt-7 rounded-2xl border border-slate-200/80 bg-gradient-to-b from-slate-50 to-white p-2.5 shadow-[0_12px_30px_rgba(15,23,42,0.05)]">
          <ul
            className="grid grid-cols-3 gap-2"
            aria-label={t("kyc.intro.eyebrow")}
          >
            <IntroRequirement
              icon={<FileCheck2 className="size-5" aria-hidden="true" />}
              title={t("kyc.intro.documentTitle")}
            />
            <IntroRequirement
              icon={<ScanFace className="size-5" aria-hidden="true" />}
              title={t("kyc.intro.selfieTitle")}
            />
            <IntroRequirement
              icon={<ReceiptText className="size-5" aria-hidden="true" />}
              title={t("kyc.intro.addressProofTitle")}
            />
          </ul>

          <div className="intro-time mt-3 flex items-center justify-center gap-2 border-t border-slate-200/80 pt-3 pb-0.5 text-sm text-slate-500">
            <Clock3 className="size-4 text-teal-700" aria-hidden="true" />
            {t("kyc.intro.time")}
          </div>
        </div>

        <button
          type="button"
          onClick={onContinue}
          className="intro-continue mt-5 inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-xl bg-teal-700 px-5 py-3 text-sm font-semibold text-white shadow-[0_10px_24px_rgba(15,118,110,0.2)] transition hover:bg-teal-800 hover:shadow-[0_12px_28px_rgba(15,118,110,0.25)] active:scale-[0.99]"
        >
          {t("kyc.intro.continue")}
          <ArrowRight className="size-4" aria-hidden="true" />
        </button>
      </div>
    </KycStep>
  );
}

function IntroRequirement({ icon, title }) {
  return (
    <li className="intro-requirement flex min-w-0 flex-col items-center rounded-xl border border-white bg-white/90 px-2 py-4 text-center shadow-sm">
      <span className="flex size-10 items-center justify-center rounded-xl bg-teal-50/80 text-teal-800 ring-1 ring-teal-100">
        {icon}
      </span>
      <span className="mt-2 text-xs font-semibold leading-4 text-slate-700 sm:text-sm">
        {title}
      </span>
    </li>
  );
}
